import React, { useEffect, useState } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import AppFooter from "../../components/AppFooter";
import "primeicons/primeicons.css";
import { useParams } from "react-router-dom";
import { Document, Page, pdfjs } from "react-pdf";
import meupdf from "../../assets/notificacao/Notificacao_Extrajudicial.pdf";
import { Api } from "../../services/Api";
import logoBranco from "../../assets/Pague_Direto_Marca-01.png";
import banner from "../../assets/notificacao/notifica_ENVELOPE.png";

import "./styles.scss"; // Import a CSS file for your component

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

function Notifica() {
  const { valid } = useParams();

  const [numPages, setNumPages] = useState(null);
  const [password, setPassword] = useState("");
  const [correctPassword, setCorrectPassword] = useState(false);
  const [actionStatus, setActionStatus] = useState(null);
  const [dataNotificado, setDataNotificado] = useState("");
  const [zoom, setZoom] = useState(1); // Inicialmente, o zoom é 1 (100%)

  useEffect(() => {
    carregaNotifica(1);
  }, []);

  useEffect(() => {
    if (actionStatus !== null) {
      enviaNofitica();
    }
  }, [actionStatus]);

  function carregaNotifica(e) {
    console.log(e);
    if (e === 1) {
      setActionStatus("Notificado_acesso");
    }
    if (e === 2) {
      setActionStatus("Notificado_aberto");
    }
  }

  async function enviaNofitica() {
    try {
      // console.log(valid)
      const { data } = await Api.post(`/log/public/notificado`, {
        action: actionStatus,
        notifica_id: valid,
      });
      // console.log(data)
      if (data.ls_action === "Notificado_aberto") {
        // console.log('EitaPorra', data)
        setCorrectPassword(true);
      } else {
        // console.log("Notificado:", data)
      }
    } catch (error) {
      console.log(error);
      // toast.error("Erro ao acessar informações do usuário");
    }
  }

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  const handleZoomIn = () => {
    setZoom(zoom + 0.1);
  };

  const handleZoomOut = () => {
    setZoom(Math.max(zoom - 0.1, 0.1)); // Impedir o zoom menor que 10%
  };

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setIsMobile(window.innerWidth <= 768); // Define a largura de tela abaixo da qual considera-se como mobile
    window.addEventListener("resize", handleResize); // Adiciona um listener para o evento resize
    return () => {
      window.removeEventListener("resize", handleResize); // Remove o listener ao desmontar o componente
    };
  }, []);

  const handleResize = () => {
    setIsMobile(window.innerWidth <= 768);
  };

  const renderPages = () => {
    const pages = [];
    for (let pageNumber = 1; pageNumber <= numPages; pageNumber++) {
      pages.push(
        <div className="pdf-page-container" key={`page_${pageNumber}`}>
          <Page
            className="pdf-page"
            pageNumber={pageNumber}
            renderTextLayer={false}
            renderAnnotationLayer={false}
            scale={isMobile ? 0.6 : zoom} // Reduz o zoom para 0.25 quando for mobile
          />
        </div>
      );
    }
    return pages;
  };

  const handlePasswordSubmit = (event) => {
    event.preventDefault();
    // Verifique se a senha está correta (isso é apenas um exemplo simples)
    if (password === "84112") {
      carregaNotifica(2);
    } else {
      alert("Senha incorreta. Tente novamente.");
    }
  };

  const handleDownloadPDF = () => {
    const link = document.createElement("a");
    link.href = meupdf; // URL do PDF
    link.target = "_blank";
    link.download = "Notificação.pdf"; // Nome do arquivo para download
    link.click();
  };

  return (
    <>
      <div className="h-screen w-screen custom-div-notifica" style={{ textAlign: "-webkit-center" }}>
        {!correctPassword ? (
          <div className="grid h-full md:flex md:items-center">
            <div className="banner-image md:order-1 md:block hidden">
              <img
                // className="h-full"
                src={banner}
                alt="cliente-logo"
                // style={{ height: "80%" }}
              />
            </div>
            <div className="pdf-content self-center px-6 md:px-0 md:w-1/2 md:order-2">
              <div className="pdf-content">
                <div className="pdf-info">
                  <h1 className="pdf-title">
                    Olá, <b className="font-tilt">Homero de M. Leão Neto</b>
                  </h1>
                  <h1 className="pdf-title">Temos um comunicado</h1>
                  <h1 className="pdf-title">importante!</h1>
                </div>
                <div className="password-form">
                  {isMobile ? (
                    <div>
                      <div className="password-label">Você recebeu uma</div>
                      <div className="password-label md:ml-2">
                        <b className="text-blue-900">Notificação Extrajudicial</b>
                      </div>
                    </div>
                  ) : (
                    <div className="password-label">
                      Você recebeu uma <b className="text-blue-900">Notificação Extrajudicial.</b>
                    </div>
                  )}
                  <div className="px-5 md:px-0">
                    {isMobile ? (
                      <div className="password-label-2">Digite os 5 primeiros números de seu CNPJ para acessar:</div>
                    ) : (
                      <div>
                        <div className="password-label">Digite os 5 primeiros números de seu CNPJ</div>
                        <div className="password-label md:ml-2">para acessar:</div>
                      </div>
                    )}
                  </div>
                  <form onSubmit={handlePasswordSubmit}>
                    <div className="password-input w-[50%] mt-5">
                      <InputText
                        className="border-black border-2 w-full"
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                      />
                    </div>
                    <div>
                      <button
                        className="password-submit-button mt-4 px-14 py-2 bg-blue-900 text-white text-base md:text-4xl font-bold"
                        type="submit"
                        style={{ borderRadius: 10 }}
                      >
                        Enviar
                      </button>
                    </div>
                    <div>
                      <img
                        className="w-6/12 mt-10"
                        src={logoBranco}
                        alt="cliente-logo"
                        // style={{ height: "80%" }}
                      />
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="h-fit w-full custom-div-notifica">
            <div className="pdf-document">
              <div
                className={`pdf-controls ${isMobile ? "w-full" : "md:w-7/12"} place-content-center md:justify-around  sticky top-0 bg-white p-2`}
                style={{
                  zIndex: 100,
                  borderBottomLeftRadius: 10,
                  borderBottomRightRadius: 10,
                }}
              >
                {!isMobile && (
                  <Button className="p-button-rounded p-button-outlined pdf-button" onClick={handleZoomIn}>
                    Zoom In
                    <i className="pi pi-search-plus md:ml-2"></i>
                  </Button>
                )}
                {!isMobile && (
                  <Button className="p-button-rounded p-button-outlined pdf-button" onClick={handleZoomOut}>
                    Zoom Out
                    <i className="pi pi-search-minus md:ml-2"></i>
                  </Button>
                )}
                {correctPassword && (
                  <Button className="p-button-rounded p-button-outlined pdf-button" onClick={handleDownloadPDF}>
                    Download PDF
                    <i className="pi pi-download ml-2"></i>
                  </Button>
                )}
              </div>
              <div className="pdf-content" style={{ marginTop: "10px" }}>
                <Document className="w-fit" file={meupdf} onLoadSuccess={onDocumentLoadSuccess}>
                  {numPages && renderPages()}
                </Document>
              </div>
            </div>
          </div>
        )}
      </div>
      <AppFooter />
    </>
  );
}

export default Notifica;
